import React from "react";

type AdminView =
  | "overview"
  | "organizations"
  | "users"
  | "entitlements";

export function AdminDashboard(): React.ReactElement {
  const [adminView, setAdminView] =
    React.useState<AdminView>("overview");

  return (
    <div className="admin-dashboard">
      <h1>Internal Administration</h1>

      <div className="admin-actions">
        <button
          className="btn"
          onClick={() => setAdminView("organizations")}
        >
          Organizations
        </button>

        <button
          className="btn"
          onClick={() => setAdminView("users")}
        >
          Portal Users
        </button>

        <button
          className="btn"
          onClick={() => setAdminView("entitlements")}
        >
          Entitlements
        </button>
      </div>

      {adminView === "overview" && (
        <div>
          <h2>Admin Overview</h2>
          <p>
            Manage customer organizations, portal users,
            and software entitlements.
          </p>
        </div>
      )}

      {adminView === "organizations" && (
        <div>
          <h2>Organizations</h2>
        </div>
      )}

      {adminView === "users" && (
        <div>
          <h2>Portal Users</h2>
        </div>
      )}

      {adminView === "entitlements" && (
        <div>
          <h2>Entitlements</h2>
        </div>
      )}
    </div>
  );
}